export const PageTurnerKey: string = "PageTurner"
